import Siema from 'siema'

const quoteSlider = document.querySelectorAll('[data-services]')

quoteSlider.forEach((slider) => {
    let siema = slider.querySelector('.services')
    let prev = slider.querySelector('.prev')
    let next = slider.querySelector('.next')
    let slides = slider.querySelectorAll('.services .tile')
    let thumbnails = slider.querySelectorAll('[data-thumbnail]')

    // Siema config
    let instance = new Siema({
        selector: siema,
        duration: 400,
        easing: 'ease-out',
        startIndex: 0,
        perPage: 2,
        perPage: {
            576: 2,
            1024: 3,
            1200: 4,
        },
        draggable: true,
        loop: true,
        threshold: 20,
        onInit: start,
        onChange: active,
    })

    // Autoplay (optional)
    // let autoplay = setInterval(() => instance.next(), 4000)

    // Navigation
    if (prev) {
        prev.addEventListener('click', function () {
            // console.log(this, 'clicked')
            instance.prev()
            // clearInterval(autoplay)
        })
    }

    if (next) {
        next.addEventListener('click', function () {
            // console.log(this, 'clicked')
            instance.next()
            // clearInterval(autoplay)
        })
    }

    // Thumbnail navigation (optional)
    if (thumbnails) {
        thumbnails.forEach((item, slide) => {
            item.addEventListener('click', function () {
                // console.log(this, 'clicked')
                instance.goTo(slide)
                // clearInterval(autoplay)
                activeThumb(index)
            })
        })
    }

    function start() {
        slides[this.currentSlide].classList.add('--active')

        // Update CSS variable on the parent `.services`
        let services = slider.querySelector('.services')
        if (services) {
            setTimeout(() => {
                services.style.setProperty('--grid-width', '2 / 15')
            }, 250)
        }
    }

    // Add class to active slide
    function active() {
        let allSlides = slider.querySelectorAll('.services .tile')
        allSlides.forEach(slide => slide.classList.remove('--active'))

        if (allSlides[this.currentSlide]) {
            allSlides[this.currentSlide].classList.add('--active')
        }
    }

    // Update active thumbnail
    function activeThumb(slide) {
        thumbnails.forEach(item => item.classList.remove('--active'))
        thumbnails[slide].classList.add('--active')
    }
})
